import { Image, Nav } from "react-bootstrap";
import facebookIcon from '../assets/images/facebook.svg';
import instagramIcon from '../assets/images/instagram.svg';
import youtubeIcon from '../assets/images/youtube.svg';
import twitterIcon from '../assets/images/twitter.svg';
import linkedinIcon from '../assets/images/linkedin.svg';
import '../assets/scss/components/social-icons.scss';

function SocialIcons ({ links, bg }) {
    if (!links) return; // Waits for data before components mount. Handles case where links is null when daa first mounts

    const { instagram, linkedin, youtube, facebook, twitter } = links;

    return (
        <Nav as="section" className={`${bg && 'fill-bg px-3 py-1'} social-icons px-0 d-inline-flex flex-row rounded`}>
            <Nav.Link className="px-0 me-3" href={ instagram }>
                <Image src={ instagramIcon } alt="instagram" width="20" height="19" rounded />
            </Nav.Link>

            { youtube ?
                <Nav.Link className="px-0 me-3" href={ youtube }>
                    <Image src={ youtubeIcon } alt="youtube" width="20" height="19" rounded />
                </Nav.Link>
                :
                <Nav.Link className="px-0 me-3" href={ linkedin }>
                    <Image src={ linkedinIcon } alt="youtube" width="20" height="19" rounded />
                </Nav.Link>
            }

            <Nav.Link className="px-0 me-3" href={ facebook }>
                <Image src={ facebookIcon } alt="facebook" width="20" height="19" rounded />
            </Nav.Link>

            <Nav.Link className="px-0" href={ twitter }>
                <Image src={ twitterIcon } alt="twitter" width="20" height="19" rounded />
            </Nav.Link>
        </Nav>
    );
}

export default SocialIcons;